import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

function SessaoEditModal({ sessao, onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    nome: sessao.nome,
    tema: sessao.tema,
    tipo: sessao.tipo,
    categoria: sessao.categoria || 'temas_livres',
    dia: sessao.dia,
    horario_inicio: sessao.horario_inicio,
    horario_fim: sessao.horario_fim,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({ ...prevState, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const csrftoken = getCookie('csrftoken');
    const config = { headers: { 'X-CSRFToken': csrftoken } };
    
    // Usamos o método PUT para atualizar a sessão
    axios.put(`/api/sessoes/${sessao.id}/`, formData, config)
      .then(() => {
        toast.success('Sessão atualizada com sucesso!');
        onSuccess(); // Avisa o componente pai para atualizar a lista
      })
      .catch(() => {
        toast.error('Erro ao atualizar a sessão. Verifique os dados.');
      });
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Editando Sessão: {sessao.nome}</h3>
        <form onSubmit={handleSubmit} className="session-form">
          <input name="nome" value={formData.nome} onChange={handleChange} placeholder="Nome da Sessão" required />
          <input name="tema" value={formData.tema} onChange={handleChange} placeholder="Tema" required />
          <input name="tipo" value={formData.tipo} onChange={handleChange} placeholder="Tipo" required />
          <select name="categoria" value={formData.categoria} onChange={handleChange} required>
            <option value="temas_livres">📋 Temas Livres</option>
            <option value="posteres">🖼️ Pôsteres</option>
            <option value="temas_correlatos">🎤 Temas Correlatos</option>
          </select>
          <input name="dia" value={formData.dia} onChange={handleChange} type="date" required />
          <input name="horario_inicio" value={formData.horario_inicio} onChange={handleChange} type="time" data-format="HH:mm" required />
          <input name="horario_fim" value={formData.horario_fim} onChange={handleChange} type="time" data-format="HH:mm" required />
          <div className="form-actions">
            <button type="submit" className="btn-submit">Salvar Alterações</button>
            <button type="button" className="btn-close" onClick={onClose}>Cancelar</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default SessaoEditModal;